import React, { Component } from 'react'
// import { Link } from 'react-router'
// import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import styles from './invalid-code.styl'
import config from 'config'

export default class AuthCodeInvalid extends Component {
  render() {
    return (
      <div className="text--center">
        <p className={styles.message}>
          <strong>
            <FormattedMessage
              id="errors.auth_code_is_no_longer_valid"
              defaultMessage="Authorisation code is no longer valid - it may have been used or has expired"
            />
          </strong>
        </p>
        <p className={styles.note}>
          <FormattedMessage
            id="errors.please_contact_your_local_award_staff"
            defaultMessage="Please contact your local Award Staff."
          />
        </p>
        {config.webAppAddress && (
          <a
            href={config.webAppAddress || `${config.publicPath}/`}
            className="btn base-margin--bottom"
          >
            <FormattedMessage
              id="button.back_to_home"
              defaultMessage="Back to Home"
            />
          </a>
        )}
      </div>
    )
  }
}
